import { useEffect } from 'react';
import axios from 'axios';

const API = '/api';

/**
 * Lightweight page view tracker for public foresightrx.com pages.
 * Sends a single POST on mount — no cookies, no fingerprinting.
 */
export function usePageTracker(pageName) {
  useEffect(() => {
    const track = async () => {
      try {
        await axios.post(`${API}/track/pageview`, {
          page: pageName || window.location.pathname,
          referrer: document.referrer || '',
        });
      } catch {
        // Silent fail — tracking should never block UX
      }
    };
    track();
  }, [pageName]);
}
